export const COUNTRY_CODES = {
  MEXICO: 'MX',
  US: 'US'
}

export const COUNTRIES = [
  { code: COUNTRY_CODES.MEXICO, label: 'Mexico' },
  { code: COUNTRY_CODES.US, label: 'Estados Unidos' }
]
